module.exports = __webpack_public_path__ + "static/homer-220438adc1dc20dbc6f32e4a979d29b8.jpg";